// הטבה/עמלה בסכום קבוע (discountFixed/commissionFixed, ₪) או באחוזים -
// null בשדה ה-Fixed = באחוזים. ראו Migration_AddFixedAmounts.sql
const shekel = (n) => `₪${Number(n) % 1 === 0 ? Number(n) : Number(n).toFixed(2)}`;

export const discountLabel = (b) => (b?.discountFixed != null ? shekel(b.discountFixed) : `${b?.discountPercent ?? 0}%`);
export const commissionLabel = (b) => (b?.commissionFixed != null ? `${shekel(b.commissionFixed)} לעסקה` : `${b?.commissionPercent ?? 0}%`);
